import { LoadingStates } from '@pb/utils'

import { NewsState } from './types'

const initialState: NewsState = {
  newsLoadingState: LoadingStates.NotLoaded,
  isNewsPopulated: false,
  news: [],
}

export default initialState
